import React from 'react';
import PropTypes from 'prop-types';

export const LoadingSpinner = ({bgColor = 'sp-hr'}) => (
  <div className='o-spinner u-paddding-top--base u-padding-bottom--base text-center'>
    <div className={`o-spinner__b o-spinner__b1 cs-bg--${bgColor}`}></div>
    <div className={`o-spinner__b o-spinner__b2 cs-bg--${bgColor}`}></div>
    <div className={`o-spinner__b o-spinner__b3 cs-bg--${bgColor}`}></div>
  </div>
);

export const FlexLoadingSpinner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
    <LoadingSpinner />
  </div>
)

LoadingSpinner.propTypes = {
  bgColor: PropTypes.string,
}
